import { dataHooks } from '@wix/data-hooks';

export const bottomNavigationMenuDataHooks = dataHooks<{
  container: {};
}>('side-panel');
